import { render, staticRenderFns } from "./myai.vue?vue&type=template&id=3daadc4d&scoped=true&"
import script from "./myai.vue?vue&type=script&lang=js&"
export * from "./myai.vue?vue&type=script&lang=js&"
import style0 from "./myai.vue?vue&type=style&index=0&id=3daadc4d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3daadc4d",
  null
  
)

export default component.exports